import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { useT } from '../i18n/LanguageContext';

import { LanguageToggle } from './LanguageToggle';
import { ThemeModeToggle } from './ThemeModeToggle';

/** The frame of every page a person sees before signing in: sign-in, forgot password, set password. */
export const PublicPage = ({ children }: { children: ReactNode }) => {
  const t = useT();

  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 2,
        position: 'relative',
        backgroundImage: (theme) =>
          `radial-gradient(1100px 520px at 50% -12%, ${theme.palette.primary.main}1f, transparent 62%)`,
      }}
    >
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ position: 'absolute', top: 16, right: 16 }}
      >
        <LanguageToggle />
        <ThemeModeToggle />
      </Stack>

      <Card variant="outlined" sx={{ width: 420, maxWidth: '100%' }}>
        <CardContent sx={{ p: 4 }}>
          <Stack direction="row" alignItems="center" spacing={1.25} sx={{ mb: 2.5 }}>
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: 2,
                display: 'grid',
                placeItems: 'center',
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
              }}
            >
              <Inventory2OutlinedIcon sx={{ fontSize: 21 }} />
            </Box>
            <Box>
              <Typography variant="h5" sx={{ lineHeight: 1.15 }}>
                {t('app.name')}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {t('app.badge')}
              </Typography>
            </Box>
          </Stack>
          {children}
        </CardContent>
      </Card>
    </Box>
  );
};
